module.exports = __webpack_public_path__ + "static/media/fire.4610c879.svg";